export const getFilteredParams = (searchParams: URLSearchParams) => {
  const params = new URLSearchParams(searchParams.toString());
  const excludeKeys = [
    "giataId",
    "searchId",
    "tokenId",
    "title",
    "priceRange",
    "selectedHotelStarRatings",
    "amenitiesFilter",
    "sorting",
    "selectedRating",
    "searchValue",
    "page",
  ];

  excludeKeys.forEach((key) => {
    params.delete(key);
  });

  return params;
};
